import React, {Fragment} from 'react'
import { graphql, StaticQuery, navigate } from 'gatsby'
import {Elements, StripeProvider} from 'react-stripe-elements';
import PaymentForm from './PaymentForm';
import Spinner from '../Spinner'
import moment from 'moment'
import Fab from '@material-ui/core/Fab';
import { connect } from "react-redux"
import {checkEmail, checkEmailPremium, checkPhonePremium, checkNumeric, checkPhoneNumber, validateEmailDomain, emailDomainFormat} from '../../utils/Helper'
import {fieldErrors} from '../../utils/errors'
import Lock from '../../assets/lock.svg'
import GrayArrow from '../../assets/gray_arrow.svg'
import { logEvent, pushToDataLayer } from '../Analytics'

class Quiz extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            step : 0,
            contentNo: 0,
            contentType: '',
            email: '',
            phone: '',
            termCondition: false,
            emailDomainError: ''
        }
    }

    handleInput = (e) => {
        if(e.target.name === 'email'){
            this.setState({[e.target.name]: e.target.value, emailDomainError: ''})
            if(validateEmailDomain(e.target.value)){
                this.setState({email: e.target.value, emailDomainError: fieldErrors.emailDomain})
            }
        }else{
            this.setState({[e.target.name]: e.target.value})
        }        
    }

    domainCorrection = () => {
        const {email} = this.state;
		var correctEmail = emailDomainFormat(email);
        this.setState({email: correctEmail})
	}
    
    handleClick = (e) => {
        this.setState({termCondition: e.target.checked})
    }

    gotoStep = (step, page, type) => {
        this.setState({step: step, contentNo: page})

        if(typeof type !== 'undefined'){
            this.setState({contentType: type})
        }
    }

    back = (step) => {
        this.setState({step: step})
    }

    validate = () => {
        const { email, phone, termCondition } = this.state;
        const { dispatchCheckboxError, dispatchEmailError, dispatchPhoneError, dispatchStripeError, dispatchGenerateToken, dispatchDisabledButton, dispatchSubmitFrom } = this.props;

        dispatchCheckboxError('')
        dispatchEmailError('')
        dispatchPhoneError('')        
        
        if (email.length === 0) return dispatchEmailError(fieldErrors.emailEmpty)
        if (!checkEmail(email)) return dispatchEmailError(fieldErrors.invalidEmail)

        if(phone === '') return dispatchPhoneError(fieldErrors.phoneNumberEmpty)
        if(!checkNumeric(phone)) return dispatchPhoneError(fieldErrors.phoneNumber)
        if(!checkPhoneNumber(phone)) return dispatchPhoneError(fieldErrors.phoneNumberFormat)
            
        if (!termCondition) return dispatchCheckboxError(fieldErrors.terms)
        
        dispatchStripeError('');
        dispatchDisabledButton(true)
        dispatchSubmitFrom(true)

        checkEmailPremium(email, (resp) => {
            if(!resp){
                checkPhonePremium(phone, (phoneResp) => {
                    if(!phoneResp){
                        dispatchDisabledButton(true)
                        dispatchSubmitFrom(true)
                        dispatchGenerateToken(true);
                    }else{
                        dispatchPhoneError(fieldErrors.userAlreadyPremiumWithPhone)
                    }
                })
			}else{
				dispatchEmailError(fieldErrors.userAlreadyPremium);
                dispatchDisabledButton(false)
                dispatchSubmitFrom(false)
            }
        })
    }

    registerSeniorUser = () => {

        pushToDataLayer('addtocart_albert', 'Cart', 'AddToCart', 'Albert');

        const { token, dispatchStripeError, dispatchDisabledButton, dispatchSubmitFrom, dispatchSetToken } = this.props;
        const { email, phone } = this.state;
        
        
            const formState = {
                token: token,
                plan: 'senior',
                email: email,
                phone: phone,
                location: "SE",
                campaign: 'common',
                trail: 30,
                coupon: 'true',
                origin: typeof window !== 'undefined' ? window.location.href : ''
            }

            dispatchSetToken('');

            fetch(`${process.env.API_URI}/users/create`, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formState)
            })
            .then(resp => resp.json())
            .then(resp => {
                console.log('resp', resp)
                if (resp.status === 200) {
                    pushToDataLayer('addtocart_albert', 'Purchase', 'done', 'Albert');
                    navigate(
                        '/congrats',
                        { state: {email, plan: 'senior', userId: resp.userId, campaign: 'common'} }
                    )
                } else {
                    dispatchDisabledButton(false)
                    dispatchSubmitFrom(false)
                    dispatchStripeError(resp.errorMsg)
                    
                }
            })
            .catch(error => console.error(error))
        
    }

    render(){
        const { step, contentNo, contentType, email, phone, emailDomainError } = this.state;
        const { token, buttonDisabled, submitForm, stripeError, seniorEmailError, seniorCheckboxError, 
            seniorPhoneError, dispatchDisabledButton, dispatchSubmitFrom} = this.props;

        if(token !== ''){
            this.registerSeniorUser()
        }

        if(stripeError !== ''){
            dispatchDisabledButton(false)
            dispatchSubmitFrom(false)
        }

        const title = ['Berätta vad du vill ha hjälp med!', 'Tycker du matte är...'];
        const content = {
            roligt_0 : {
                        title: 'Ni har garanterat hämnat rätt.',
                        subTitle: 'Med mig får eleverna tillgång till tusentals övningar och hundratals animerade mattelektioner som garanterat ökar chanserna till ett bättre provresultat.',
                        list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Hundratals animerade mattelektioner', ' Tillgänglig 24/7', ' Inga bindningstider'],
                        note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
                    },
            
            roligt_1 : {
                title: 'Wohoo, ni har hamnat rätt!',
                subTitle: 'Hos mig hittar du tusentals roliga övningar videos som anpassats efter din årskurs!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Hundratals animerade mattelektioner', 'Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                note1: '(Ordinarie pris 99kr/månad)'
            },
            
            roligt_2 : {
                title: 'Övning ger färdighet!',
                subTitle: 'att du blir en sann mattemästare. Du kan öva på matten för din årskurs eller gå upp och läsa mer avancerade nivåer - du bestämmer!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Hundratals animerade mattelektioner', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            },
            
            mest_0 : {
                title: 'Känn ingen press.',
                subTitle: 'Välj i lugn och ro bland massor med övningar. Mina videos förklarar allt mina elever behöver kunna på ett roligt och enkelt sätt. Plugga med mig tio minuter om dagen så kommer det gå fint!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Hundratals animerade mattelektioner', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            },

            mest_1 : {
                title: 'Jag finns här för att göra det roligare och enklare.',
                subTitle: 'Alla mina uppgifter har tagits fram av erfarna pedagoger, lärare och forskare - allt för att matten ska bli så kul som möjligt! Testa er fram bland alla tusentals övningar, i egen takt - när ni vill!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Hundratals animerade mattelektioner', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: ''
            },

            mest_2 : {
                title: 'Känn ingen press, jag är alltid tillgänglig.',
                subTitle: 'Att förstå matte kan vara svårt, men jag finns här för att hjälpa mina elever hela vägen. Med övning och tålamod kommer resultaten komma - garanterat! Öva i appen minst 10 minuter om dagen så kommer det gå fint!',
                list: [' Kopplad till läroplanen', ' Tusentals roliga övningar', ' Hundratals animerade mattelektioner', ' Tillgänglig 24/7', ' Inga bindningstider'],
                note: 'Testa gratis idag!',                 note1: '(Ordinarie pris 99kr/månad)'
            }

            
        }

        return(
            <section className="steps-section" id="quiz">
                <div className="custom-container">
                    <div className="for-back">
                        <div className="steps-inner">
                                <ul>
                                    <li className={step === 0 ? 'active step-0' : (step > 0 ? 'done' : '') }>
                                     
                                        <span></span>
                                    </li>
                                    <li className={step === 1 && step > 0 ? 'active step-1' : (step > 1 ? 'done' : '')}>
                                        <span></span>
                                    </li>
                                    <li className={step === 2 && step > 1 ? 'active step-2' : (step > 2 ? 'done' : '')}>
                                        <span></span>
                                    </li>
                                    <li className={step === 3 && step > 1 ? 'active step-3' : (step > 3 ? 'done' : '')}>
                                        <span></span>
                                    </li>
                                  <div className="for-active"></div>
                                </ul>
                                {
                                    title[step] && (
                                        <h3>{title[step]}</h3>
                                    )
                                }
                                <div className="new-midd-sec">
                                    {
                                        step === 0 && (
                                            <Fragment>
                                                <button type="button" onClick={e => {
                                                        this.gotoStep(1, 0);
                                                        logEvent(
                                                            `Senior quiz Klara nästa matteprov button`,
                                                            `Senior quiz Klara nästa matteprov button was clicked`
                                                            );
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Senior Quiz Klara Nästa Matteprov Button',
                                                            'Senior Quiz Klara Nästa Matteprov Button Was Clicked'
                                                        )
                                                    }
                                                }
                                                >
                                                    Klara nästa matteprov
                                                </button>
                                                <button type="button" onClick={e => {
                                                    this.gotoStep(1, 1);
                                                    logEvent(
                                                        `Senior quiz Göra matten roligare button`,
                                                        `Senior quiz Göra matten roligare button was clicked`
                                                    );
                                                    pushToDataLayer(
                                                        'userClick',
                                                        'Senior Quiz Göra Matten Roligare Button',
                                                        'Senior Quiz Göra Matten Roligare Button Was Clicked'
                                                    )
                                                }
                                                }
                                                >
                                                    Göra matten roligare
                                                </button>
                                                <button type="button" onClick={e => {
                                                    this.gotoStep(1, 2);
                                                    logEvent(
                                                        `Senior quiz Bli en mattemästare button`,
                                                        `Senior quiz Bli en mattemästare button was clicked`
                                                    );
                                                    pushToDataLayer(
                                                        'userClick',
                                                        'Senior Quiz Bli en Mattemästare Button',
                                                        'Senior Quiz Bli en Mattemästare Button Was Clicked'
                                                    )
                                                }
                                                }
                                                >
                                                    Bli en mattemästare
                                                </button>
                                            </Fragment>
                                        )
                                    }

                                    {
                                        step === 1 && (
                                            <Fragment>
                                                <button type="button" onClick={e => {
                                                        this.gotoStep(2, contentNo, 'roligt');
                                                        logEvent(
                                                            `Senior quiz Roligt button`,
                                                            `Senior quiz Roligt button was clicked`
                                                        );
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Senior Quiz Roligt Button',
                                                            'Senior Quiz Roligt Button Was Clicked'
                                                        )
                                                    }
                                                }
                                                >
                                                    Roligt
                                                </button>
                                                <button type="button" onClick={e => {
                                                        this.gotoStep(2, contentNo, 'mest');
                                                        logEvent(
                                                            `Senior quiz Mest jobbigt button`,
                                                            `Senior quiz Mest jobbigt button was clicked`
                                                        );
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Senior Quiz Mest Jobbigt Button',
                                                            'Senior Quiz Mest Jobbigt Button Was Clicked'
                                                        )
                                                    }
                                                }
                                                >
                                                    Mest jobbigt
                                                </button>

                                                <span className="backQuizBtn"  onClick={e => {
                                                        this.back(0);
                                                        logEvent(
                                                            `Senior quiz Tillbaka button`,
                                                            `Senior quiz Tillbaka button was clicked`
                                                        );
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Senior Quiz Tillbaka Button',
                                                            'Senior Quiz Tillbaka Button Was Clicked'
                                                        )
                                                    }
                                                }
                                                ><GrayArrow /> Tillbaka</span>
                                            </Fragment>
                                        )
                                    }

                                    {
                                        step === 2 && (
                                            <Fragment>
                                                <h3>{content[contentType+'_'+contentNo].title}</h3>
                                                <p>{content[contentType+'_'+contentNo].subTitle}</p>
                                                    <ul>
                                                    {
                                                        content[contentType+'_'+contentNo].list.map((n, key) => {
                                                            return (
                                                                <li key={key} >{n}</li>
                                                            )
                                                        })
                                                    }
                                                    </ul>
                                                
                                                {
                                                    content[contentType+'_'+contentNo].note && (
                                                        <p><b>{content[contentType+'_'+contentNo].note}</b></p>
                                                    )
                                                }
                                                {
                                                    content[contentType+'_'+contentNo].note1 && (
                                                        <p><i>{content[contentType+'_'+contentNo].note1}</i></p>
                                                    )
                                                }
                                                
                                                <button type="button" onClick={e => {
                                                        this.gotoStep(3, contentNo, contentType);
                                                        logEvent(
                                                            `Senior quiz Registrera button`,
                                                            `Senior quiz Registrera button was clicked`
                                                        );
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Senior Quiz Registrera Button',
                                                            'Senior Quiz Registrera Button Was Clicked'
                                                        )
                                                    }
                                                }
                                                >Registrera</button>
                                                <span className="backQuizBtn"  onClick={e => {
                                                        this.back(1);
                                                        logEvent(
                                                            `Senior quiz Tillbaka button`,
                                                            `Senior quiz Tillbaka button was clicked`
                                                        );
                                                        pushToDataLayer(
                                                            'userClick',
                                                            'Senior Quiz Tillbaka Button',
                                                            'Senior Quiz Tillbaka Button Was Clicked'
                                                        )
                                                    }
                                                }
                                                ><GrayArrow /> Tillbaka</span>
                                            </Fragment>
                                        )
                                    }

                                    {
                                        step === 3 && (
                                            <StripeProvider apiKey={process.env.STRIPE_PK}>
                                                <form>
                                                    <h3>Registrera dig</h3>
                                                    <div className='accountFormEmail'>
                                                        <h4>E-post</h4>
                                                        <input className={seniorEmailError!== '' ? 'errorField' : ''} placeholder="Ange E-postadress" type='email' name="email" id='email' value={email} onBlur={() => this.domainCorrection()} onChange={e => this.handleInput(e)}/>
                                                        <label className="text-error">{seniorEmailError}</label>
                                                        <label className="text-error">{emailDomainError}</label>
                                                    </div>

                                                    <div className='accountFormEmail'>
                                                        <h4>Ditt barns Telefonnummer</h4>
                                                        <input className={seniorPhoneError!== '' ? 'errorField' : ''} placeholder="Ange mobilnummer"  type='text' name="phone" id='phone' value={phone} onChange={e => this.handleInput(e)} pattern="\d*"/>
                                                        <label className="text-error">{seniorPhoneError}</label>
                                                    </div>

                                                    <Elements>
                                                        <PaymentForm />
                                                    </Elements>
                                                    <label className="text-error">{stripeError}</label>

                                                    <div className='accountFormRegisterButtonMobile'>
                                                        <input type='checkbox' id='terms_and_conditions' onChange={e => this.handleClick(e)} />
                                                        <label htmlFor='terms_and_conditions'>Jag godkänner Alberts <a href="/terms-and-conditions" target="_blank" className='color-text'> Allmänna Villkor </a></label>
                                                    </div>
                                                    <label className="text-error">{seniorCheckboxError}</label>

                                                    <Fab
                                                        variant="extended"
                                                        // size="small"
                                                        color="primary"
                                                        aria-label="Add"
                                                        className="registerButton payment-btn"
                                                        disabled={buttonDisabled}
                                                        onClick={e => {
                                                            this.validate();
                                                            logEvent(
                                                                `Senior quiz Påbörja din gratisperiod button`,
                                                                `Senior quiz Påbörja din gratisperiod button was clicked`
                                                            );
                                                            pushToDataLayer(
                                                                'userClick',
                                                                'Senior Quiz Påbörja Din Gratisperiod Button',
                                                                'Senior Quiz Påbörja Din Gratisperiod Button Was Clicked'
                                                            )
                                                        }}
                                                        
                                                        >
                                                        Påbörja din gratisperiod
                                                    </Fab>
                                                    
                                                    {
                                                        submitForm && (
                                                            <div className="loader-cenetr"> <Spinner size={48}/></div>
                                                        )
                                                    }

                                                    <h6><Lock /> &nbsp; Säker kortbetalning via en krypterad anslutning.</h6>
                                                    {/* <h6>Bra att veta: Efter 30 dagar övergår gratiskontot till ett premiumkonto för 99kr/mån. Du kan närsomhelst, utan uppsägningstid, avsluta ditt abonnemang genom att logga in på Mina Sidor.</h6> */}
                                                    <h6>Bra att veta: Prenumerationen är helt gratis i 30 dagar, därefter 99kr/mån. Du kan närsomhelst, utan uppsägningstid, avsluta ditt abonnemang genom att logga in på Mina Sidor.</h6>
                                                </form>
                                            </StripeProvider>
                                        )
                                    }
                                </div>
                        </div>
                    </div>	
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.seniorToken,
        submitForm: state.seniorFormSubmit,
        stripeError: state.seniorStripeError,
        buttonDisabled: state.buttonDisabled,
        seniorEmailError: state.seniorEmailError,
        seniorPhoneError: state.seniorPhoneError,
        seniorCheckboxError: state.seniorCheckboxError
    }
}
  
const mapDispatchToProps = dispatch => {
    return { 
        dispatchSetToken: (token) => dispatch({ type: `SENIOR_TOKEN`, value: token }),
        dispatchSubmitFrom: (status) => dispatch({ type: `SENIOR_FORM_SUBMIT`, value: status }),
        dispatchStripeError: (error) => dispatch({ type: `SENIOR_STRIPE_ERROR`, value: error }),
        dispatchGenerateToken: (status) => dispatch({ type: `SENIOR_GENERATE_TOKEN`, value: status }),
        dispatchDisabledButton: (status) => dispatch({ type: `DISABLED_BUTTON`, value: status }),
        dispatchEmailError: (status) => dispatch({ type: `SENIOR_EMAIL_ERROR`, value: status }),
        dispatchPhoneError: (status) => dispatch({ type: `SENIOR_PHONE_ERROR`, value: status }),
        dispatchCheckboxError: (status) => dispatch({ type: `SENIOR_CHECKBOX_ERROR`, value: status }),
    }
}
  
const QuizClass = connect(mapStateToProps, mapDispatchToProps)(Quiz)

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    iPhone: file(relativePath: {regex: "/iphone-mob/"}) {
                        publicURL
                    }                    
                }`
            }
        render={(data)  => (
           <QuizClass query={data} {...props}/>
        )}
    />
)